/**
 * Каталог подрядчиков Блока 8 — константы экрана категорий 2.8.1 (ADR-0080).
 * UI-источник истины — прототип `Партнеры/01-prototype-vanilla/screen-2.8-partners.html`.
 *
 * Словарь категорий/подкатегорий вынесен в единый источник `packages/shared`
 * (ADR-0098). Здесь — re-export для back-compat: потребители в `features/partners`
 * (`PartnersCategories`, `PartnersList`, `PartnersListView`, `categorySlugs`)
 * продолжают импортировать отсюда.
 */
export { PARTNER_CATEGORIES, RASPIL_CATEGORY, RASPIL_SUBCATEGORIES } from '@pomoshnik/shared';
export type { PartnerCategory, RaspilSubcategory } from '@pomoshnik/shared';

/**
 * Видеоинструкция экрана «Партнёры» (P-040). Placeholder — реальный YouTube-embed
 * заменит Aibek (как DECOR/HANDLES/FURNITURE_VIDEO_URL в shared). Партнёр-специфична,
 * остаётся локально в feature.
 */
export const PARTNERS_VIDEO_URL = 'https://www.youtube.com/embed/PLACEHOLDER_PARTNERS_INTRO';
